<template>
    <div class="avatar__container mb-10">
        <template v-if="editAvatar || !avatarThumb">
            <y-uploader
                v-if="!removed"
                :key="keyHelper"
                ref="uploader"
                :max-file-size="element.max_volume_files"
                :accepted-files="element.allowed_extensions"
                :max-files="element.max_number_files"
                :payload="element.payload"
                :files="avatarImg"
                no-label
                simple
                small
                @success="addAvatarFile"
            />
            <template v-else-if="removed">
                <div class="avatar__image">
                    <y-image
                        circle
                        width="80px"
                        height="80px"
                        :src="avatarThumb"
                        icon="trash"
                        mini
                        it-self
                        color="success"
                        icon-size="small"
                        closeable
                        @click="removeAvatarFile"
                        @close="goBack"
                    />
                </div>
            </template>
        </template>


        <template v-else>
            <div
                v-if="!removed && hasAvatar && !editAvatar"
                class="avatar__image"
            >
                <y-image
                    circle
                    width="80px"
                    height="80px"
                    :src="avatarThumb"
                    icon="camera"
                    :method="toggleEditAvatar"
                    mini
                    it-self
                    color="success"
                    icon-size="small"
                />
            </div>
        </template>
    </div>
</template>

<script>
    import {
        YUploader, YImage,
    } from '@components';
    import { generateId } from '@nodes/helpers/string';

    export default {
        name: 'Avatar',

        components: {
            YUploader,
            YImage,
        },

        props: {
            user             : Object,
            userMetadata     : Object,
            hasAvatar        : Boolean,
            hasAvatarResource: Boolean,
        },

        /**
         * @inheritDoc
         */
        data() {
            return {
                avatarID  : null,
                editAvatar: false,
                newAvatar : false,
                removed   : false,
                keyHelper : generateId(),
            };
        },

        computed: {
            /**
             * Return the avatar object
             * 
             * @returns {object} 
             */
            element() {
                return this.userMetadata && this.userMetadata.avatar ? this.userMetadata && this.userMetadata.avatar : null;
            },

            /**
             * Return the avatar image
             * 
             * @returns {*} 
             */
            avatarImage() {
                return this.userMetadata && this.userMetadata.avatar
                    && this.userMetadata.avatar.resource && this.userMetadata.avatar.resource.length ? this.userMetadata.avatar.resource : [];
            },

            /**
             * Avatar Thumbnail Image
             * 
             * @returns {string} 
             */
            avatarThumb() {
                return this.userMetadata && this.userMetadata.avatar
                    && this.userMetadata.avatar.resource && this.userMetadata.avatar.resource.length && this.userMetadata.avatar.resource[0].versions ? this.userMetadata.avatar.resource[0].versions.panel_thumb : null;
            },
        },

        methods: {
            /**
             * Toggle editAvatar state
             */
            toggleEditAvatar() {
                this.editAvatar = !this.editAvatar;
                this.removed = !this.removed;
            },

            /**
             * Handle successful avatar upload
             *
             * @param {object} file
             */
            addAvatarFile(file) {
                this.newAvatar = true;
                this.removed = false;
                this.avatarID = [file.id];
                this.avatarImg = [file];
                this.$emit('changed', this.avatarID);
            },

            /**
             * Handle avatar file removal
             */
            removeAvatarFile() {
                this.newAvatar = false;
                this.removed = !this.removed;
                this.avatarImg = [];
                this.avatarID = null;
                this.$emit('changed', this.avatarID);
            },

            /**
             * Cancel remove avatar
             */
            goBack() {
                this.editAvatar = !this.editAvatar;
                this.removed = !this.removed;
            },

        },
    };
</script>
